import { Share2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useShareActions } from '../../hooks/use-share-action'

export function ShareMessageButton({ messageId }: { messageId: string }) {
  const { enterShareMode } = useShareActions()

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant='ghost'
            size='icon'
            className='hover:text-primary size-6 text-muted-foreground transition-all'
            onClick={(e) => {
              e.stopPropagation()
              enterShareMode(messageId)
            }}
          >
            <Share2 className='size-3' />
          </Button>
        </TooltipTrigger>
        <TooltipContent className='text-[10px]'>分享对话</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
